import React, { useCallback, useEffect, useState } from 'react'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form } from 'react-bootstrap'
import './Inputs.css'

const defaultMinLenght = 8

interface IPasswordInputProp {
  value?: string
  errorMessage?: string
  required?: boolean
  placeholder?: string
  onChange: (newValue: string, isValid: boolean) => void
  onEntered?: (newValue: string, isValid: boolean) => void
  maxLength?: number
  minLength?: number
  style?: React.CSSProperties
}

const checkPassword = (pswd: string, minLength: number): boolean => {
  if (pswd.length < minLength) return false

  return true
}

const PasswordInput: React.FC<IPasswordInputProp> = ({
  value: valueProp,
  errorMessage,
  required,
  placeholder,
  onChange,
  onEntered,
  maxLength,
  minLength,
  style,
}: IPasswordInputProp) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isFirstInput, setIsFirstInput] = useState(true)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (valueProp !== undefined) {
      setValue(valueProp)
    }
  }, [valueProp])

  const isPasswordInvalid = useCallback(() => {
    if (isFirstInput) {
      return false
    }
    if (errorMessage) {
      return true
    }
    if (!checkPassword(value, minLength || defaultMinLenght)) return true

    return false
  }, [errorMessage, value, minLength, isFirstInput])

  const handleChangePassword = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value_ =
        maxLength && event.target.value.length > maxLength
          ? event.target.value.substring(0, maxLength)
          : event.target.value

      setValue(value_)
      setIsFirstInput(false)
      onChange(value_, checkPassword(value_, minLength || defaultMinLenght))
    },
    [minLength, maxLength, onChange]
  )

  const handleBlur = () => {
    setIsFirstInput(false)
    onChange(value, checkPassword(value, minLength || defaultMinLenght))
  }

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onEntered && event.key === 'Enter')
        onEntered(value, checkPassword(value, minLength || defaultMinLenght))
    },
    [onEntered, value, minLength]
  )

  const handleChangeVisibility = useCallback(() => {
    setIsVisible(!isVisible)
  }, [isVisible])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
      <div style={{ display: 'flex' }}>
        <Form.Control
          value={value}
          type={isVisible ? 'text' : 'password'}
          placeholder={placeholder || ''}
          onChange={handleChangePassword}
          maxLength={maxLength}
          className={
            isFirstInput || !required
              ? ''
              : isPasswordInvalid()
              ? 'is-invalid'
              : 'is-valid'
          }
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          required
          style={{ borderRadius: '0px', zIndex: '2' }}
        />
        <div
          style={{
            padding: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid var(--bs-gray-400)',
            marginLeft: '-1px',
          }}
          onClick={handleChangeVisibility}
        >
          {isVisible ? (
            <FontAwesomeIcon icon={faEyeSlash} />
          ) : (
            <FontAwesomeIcon icon={faEye} />
          )}
        </div>
      </div>
      <div
        className='invalid-feedback'
        style={{ display: isPasswordInvalid() && required ? 'block' : 'none' }}
      >
        {errorMessage
          ? errorMessage
          : `Пароль должен содержать не менее ${minLength || defaultMinLenght} символов`}
      </div>
    </div>
  )
}
export default PasswordInput
